import { DATA_COLLECTION_CONFIGS } from "pages/dataCollection/_shared/config";
import { DataCollectionPage } from "pages/dataCollection/_shared/DataCollectionPage";

function Bylaws() {
  return <DataCollectionPage config={DATA_COLLECTION_CONFIGS.bylaws} />;
}

export default Bylaws;
